import { HOUSEHOLD_DOC } from '@awwyeah/shared';
import type { WebModule } from '../registry';
import { HouseholdPage } from './HouseholdPage';

export { HouseholdContent } from './HouseholdPage';

/**
 * Household module (client side): minimal members + invite screen for now; the full
 * design (Screen G — profiles, birthdays UI, preferences) is WS-10/Phase 2.
 *
 * No `nav` entry (owner call, 2026-07-31, docs/DECISIONS.md): `HouseholdContent` is
 * embedded at the top of Settings instead of taking its own tab/nav slot. The route
 * stays live at `/household` for deep links and existing tests.
 */
export const householdWebModule: WebModule = {
  id: 'household',
  routes: [{ path: '/household', component: HouseholdPage }],
  docs: [HOUSEHOLD_DOC],
};
